import React from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Pagination,
  Stack,
  useMediaQuery,
} from '@mui/material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ManIcon from '@mui/icons-material/Man';
import {
  BackdropLoading,
  BookButton,
  BookSearchField,
  CardComponent,
} from '../../components';

import { WHITE_COLOR, GREY_COLOR } from '../../styles/constants';
import { TableHeadComponent, TableRows } from '../../components';
import LanguageModal from '../modals/language';
import { useTheme } from '@mui/material/styles';
import { useLanguage } from './hooks/language.hook';
import { useStyles } from './language.style';
import AddIcon from '@mui/icons-material/Add';

const LanguageTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    languageData,
    action,
    languageCount,
    open,
    setOpen,
    singleLanguage,
    tableCells,
    actionsIcons,
    limit,
    page,
    isLoading,
    handleGetLanguageData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleLanguageSearch,
  } = useLanguage();

  const dataIcons = [
    { id: 'name', title: 'Name', gridTitleSize: 5, gridSize: 6 },
    {
      id: 'direction',
      title: 'direction',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <ContactPhoneIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
  ];

  return (
    <Box component='div' sx={isMobile && { paddingBottom: 10 }}>
      {open && (
        <LanguageModal
          tableCells={tableCells}
          open={open}
          setOpen={setOpen}
          singleLanguage={singleLanguage}
          action={action}
          handleGetLanguageData={handleGetLanguageData}
        />
      )}
      <BackdropLoading open={isLoading} />
      <Box
        component='div'
        sx={{
          width: '100%',
          position: isMobile && 'sticky',
          top: isMobile && '7rem',
          zIndex: isMobile && 1000,
          background: 'white',
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={10} lg={10} sx={{ textAlign: 'end' }}>
            {/* <BookSearchField
              type='text'
              handleSearch={handleLanguageSearch}
              sx={{ width: isMobile ? '100%' : '50%' }}
            /> */}
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <BookButton
              onSubmit={handleAdd}
              title='Add Language'
              type='primary'
              variant='contained'
              icon={<AddIcon />}
            />
          </Grid>
        </Grid>
      </Box>
      {isMobile ? (
        <>
          {languageData &&
            Object.keys(languageData).length > 0 &&
            languageData?.map(row => (
              <CardComponent
                key={'languageDara' + row.id}
                sx={{
                  background: GREY_COLOR.GHOSTWHITE,
                  width: '97%',
                  margin: '20px 5px 5px 5px',
                }}
                classBorder={
                  Object.keys(row['measurement']).length > 0
                    ? classes.statusCompleted
                    : classes.statusPending
                }
                titleStyle={classes.titleStyle}
                uniqueKey='-languageCrud'
                rows={row}
                dataIcons={dataIcons}
                tableCells={tableCells}
                actionsIcons={actionsIcons}
                handleActionClick={handleActionClick}
              />
            ))}
          <Stack className={classes.paginationStyle} spacing={2}>
            <Pagination
              count={calculatePagesCount(limit, languageCount)}
              page={page + 1}
              onChange={(event, newPage) => handleChangePage(true, newPage)}
              color='primary'
            />
          </Stack>
        </>
      ) : (
        <>
          <TableContainer
            sx={{
              width: '100%',
              background: WHITE_COLOR,
            }}
          >
            <Table sx={{ minWidth: '100%' }} aria-label='simple table'>
              <TableHeadComponent tableCells={tableCells} />
              <TableBody>
                <TableRows
                  uniqueKey='-languageCrud'
                  tableCells={tableCells}
                  rows={languageData}
                  actionsIcons={actionsIcons}
                  handleActionClick={handleActionClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={languageCount}
            page={page}
            onPageChange={(event, newPage) => handleChangePage(false, newPage)}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[25, 50, 100, 250, 500, 750, 1000]}
          />
        </>
      )}
    </Box>
  );
};
export default LanguageTable;
